module.exports = __webpack_public_path__ + "img/flur_00.9eb0dcd3.png";